// ----------------------------------------------------------------------------
// Section: Video Gallery
// ----------------------------------------------------------------------------

// Styles
import './_video-gallery.scss';

// -------------------------------------
// Inline video playback
// -------------------------------------
// Clicking a card poster reveals a YouTube iframe inline in the portrait card.
// No modal — the video plays within the card itself (ideal for Shorts/vertical).

const initVideoGallery = () => {
    document.querySelectorAll('.video-gallery__card[data-video-id]').forEach((card) => {
        if (card.dataset.videoGalleryInit) return;
        card.dataset.videoGalleryInit = 'true';

        const poster = card.querySelector('.video-gallery__card-poster');
        const embed  = card.querySelector('.video-gallery__card-embed');
        const videoId = card.dataset.videoId;

        if (!poster || !embed || !videoId) return;

        poster.addEventListener('click', () => {
            const iframe = document.createElement('iframe');
            iframe.src = `https://www.youtube.com/embed/${videoId}?autoplay=1&rel=0&playsinline=1`;
            iframe.title = poster.getAttribute('aria-label') || 'Video';
            iframe.allow = 'autoplay; encrypted-media; fullscreen';
            iframe.allowFullscreen = true;

            embed.appendChild(iframe);

            poster.hidden = true;
            embed.removeAttribute('hidden');
            embed.removeAttribute('aria-hidden');
        });
    });
};

document.addEventListener('DOMContentLoaded', initVideoGallery);

// Re-run after Shopify section re-renders in the theme editor
document.addEventListener('shopify:section:load', initVideoGallery);
